"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicSourceProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class DynamicSourceProvider {
  constructor() {
    (0, _defineProperty2.default)(this, "name", "dynamic");
  }
  getValue(provider, source, arg) {
    let value = this._value(provider, source, arg);
    return {
      value() {
        return value;
      }
    };
  }
  _value(provider, source, arg) {
    return provider.getInput(source.name, arg.typing);
  }
}
exports.DynamicSourceProvider = DynamicSourceProvider;
//# sourceMappingURL=DynamicSourceProvider.js.map